import { Outlet, useLocation } from "react-router-dom";

import Footer from "../partials/Footer";
import {Header} from "../partials/Header";
import { OverlayBody } from "../ui/atoms/OverlayBody";
import { useEffect, useState } from "react";

const LayoutPage = () => {

  const [scrollHeader, setScrollHeader] = useState(true);
  const [showFooter, setShowFooter] = useState(true);

  const location = useLocation();

  useEffect(() => {
    const pathName = location?.pathname;
    
    if (pathName === "/campagnes" || pathName === "/actus") {
      setScrollHeader(false);
      setShowFooter(false);
    } else {
      setScrollHeader(true);
      setShowFooter(true);
    }

  }, [scrollHeader, location]);

  return (
    <>
      <Header scrollHeader={scrollHeader} />
      <OverlayBody />
      <main>
        <Outlet />
      </main>
      <Footer showFooter={showFooter} />
    </>
  );
};

export default LayoutPage;
